module.exports = __webpack_public_path__ + "static/media/238.63ef34f7.png";